import { gql } from '@apollo/client';
import TENANT_MANUFACTURER from 'api/fragments/TENANT_MANUFACTURER';
const ADD_TENANT_MANUFACTURER = gql `
  ${TENANT_MANUFACTURER}
  mutation AddTenantManufacturer(
    $tenantId: ID!
    $name: String!
    $shortName: String!
    $vatNumber: String
    $countryOfOrigin: String
    $addressPostalCode: String
    $addressCity: String
    $addressStreet: String
    $addressNumber: String
    $emailAddress: String
    $contactPhone: String
    $employeesCount: Int
  ) {
    addManufacturer(
      tenantId: $tenantId
      name: $name
      shortName: $shortName
      vatNumber: $vatNumber
      countryOfOrigin: $countryOfOrigin
      addressPostalCode: $addressPostalCode
      addressCity: $addressCity
      addressStreet: $addressStreet
      addressNumber: $addressNumber
      emailAddress: $emailAddress
      contactPhone: $contactPhone
      employeesCount: $employeesCount
    ) {
      manufacturer {
        ...TenantManufacturerFragment
      }
    }
  }
`;
export default ADD_TENANT_MANUFACTURER;
